import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { IdentityProvider } from '@vp/ubik-context'

import { getLocaleSelector } from '~/client/store/config'
import { createAuthConfig } from 'client/components/common/getAuthConfig'

export const IdentityProviderWrapper = ({ children }: PropsWithChildren) => {
  const locale = useSelector(getLocaleSelector)

  return <IdentityProvider auth={createAuthConfig(locale)}>{children}</IdentityProvider>
}
